class ProductItemWrapper extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    const url = this.getAttribute('data-url');
    if (url) {
      this.style.cursor = 'pointer';
      this.addEventListener('click', this.handleClick);
      this.setAttribute('tabindex', '0'); // for keyboard accessibility
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(event) {
    // Avoid following the link if the user clicked on a real <a>
    if (event.target.closest('a')) return;

    const url = this.getAttribute('data-url');
    if (url) {
      window.location.href = url;
    }
  }
}

customElements.define('product-item-wrapper', ProductItemWrapper);
